import {UserInviteButton} from "./user.invite.button";
import { UserInviteForm } from "./user.invite.form";

export const UserInvite = {
    Button: UserInviteButton,
    Form: UserInviteForm
}